import { Link } from 'react-router-dom';
import { getAllArticles } from '../utils/articleLoader';
import { getAllCategories, getPagesByCategory } from '../utils/seoPageLoader';

function InternalLinks() {
  const articles = getAllArticles();
  const categories = getAllCategories();
  const featuredGuides = getPagesByCategory('questions').slice(0, 4);

  return (
    <section className="py-10 bg-white rounded-xl shadow-sm border p-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-5">
        Explore More
      </h2>
      
      {/* Categories */}
      <div className="mb-6">
        <h3 className="text-lg font-medium text-gray-900 mb-3">Categories</h3>
        <div className="grid md:grid-cols-3 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="p-4 rounded-lg border hover:bg-gray-50 transition"
            >
              <h4 className="font-medium text-gray-900 mb-1">
                {cat.title}
              </h4>
              <p className="text-sm text-gray-600">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>

      {/* Featured Guides */}
      <div className="mb-6">
        <h3 className="text-lg font-medium text-gray-900 mb-3">Featured Guides</h3>
        <div className="grid md:grid-cols-2 gap-3">
          {featuredGuides.map((guide) => (
            <Link
              key={guide.slug}
              to={`/guides/${guide.slug}`}
              className="p-4 rounded-lg border hover:bg-gray-50 transition"
            >
              <h4 className="font-medium text-gray-900 mb-1">
                {guide.title}
              </h4>
              <p className="text-sm text-gray-600">
                {guide.description}
              </p>
            </Link>
          ))}
        </div>
      </div>

      {/* Articles */}
      <div>
        <h3 className="text-lg font-medium text-gray-900 mb-3">Articles</h3>
        <div className="grid md:grid-cols-2 gap-3">
          {articles.slice(0, 4).map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="p-4 rounded-lg border hover:bg-gray-50 transition"
            >
              <h4 className="font-medium text-gray-900 mb-1">
                {article.title}
              </h4>
              <p className="text-sm text-gray-600">
                {article.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default InternalLinks;
